module.exports = __webpack_public_path__ + "static/media/click1.d217c31b.mp3";